module.exports = __webpack_public_path__ + "img/59.7d844fc8.png";